import { useEffect } from 'react';
import { axiosAvmApi } from 'api/axios.paylater-api';

const useApi = () => {

    useEffect(() => {
        const requestIntercept = axiosAvmApi.interceptors.request.use(
            async (config) => {
                return config
            },
            (error) => Promise.reject(error)
        );

        const responseIntercept = axiosAvmApi.interceptors.response.use(
            (response) => response,
            async (error) => {
                const prevRequest = error?.config;
                if (error?.response?.status === 401 && !prevRequest?.sent) {
                    prevRequest.sent = true;

                    return axiosAvmApi(prevRequest);
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axiosAvmApi.interceptors.request.eject(requestIntercept);
            axiosAvmApi.interceptors.response.eject(responseIntercept);
        };
    }, []);

    return axiosAvmApi;
};

export default useApi;
